import { Typography } from "@material-tailwind/react";

type FeatureProps = {
  icon: string;
  title: string;
  active: boolean;
  onClick: () => void;
};
function featureCard({ icon, title, active, onClick }: FeatureProps) {
  return (
    <div
      onClick={() => onClick()}
      className={
        active
          ? `border h-24 w-32 border-gray-800 rounded-md bg-gray-900 text-white p-5`
          : `border h-24 w-32 border-gray-800 rounded-md p-5`
      }
    >
      <img
        src={icon}
        className={
          active
            ? " h-10 w-10 mx-auto bg-blend-color-burn invert"
            : " mx-auto h-10 w-10"
        }
      />
      <Typography  placeholder={undefined}  className="text-center text-sm">{title}</Typography>
    </div>
  );
}

export default featureCard;
